module.exports = __webpack_public_path__ + "static/img/comshow_two.c78326c0.jpg";